import React from "react";

// Components
import { Seo } from "../Utils";
import Button from "../Atoms/Button";
import { ImgixBackgroundImage } from "../Utils/ImgixImage";

// Stylesheets
import "./PageNotFound.scss";

export const PageNotFound = () => {
  const imageProps = {
    imgixProps: {
      fit: "unset",
      q: "90",
    },
    inlineStyles: {
      backgroundPosition: "10% 100%",
      maxWidth: "1140px",
      margin: "0 auto",
    },
  };

  return (
    <main className="page_not_found page">
      <Seo title="Page Not Found" titleOnly />

      <ImgixBackgroundImage
        className="hero_image"
        src="404-sleep.jpg"
        imgixProps={imageProps.imgixProps}
        htmlAttributes={{ style: imageProps.inlineStyles }}
      >
        <div className="container">
          <div className="main_content">
            <h1 className="h1_text">Page not found.</h1>
            <h2 className="h1_text">
              Someone must've <br className="is_mobile" />
              been sleeping...
            </h2>

            <Button
              className="back_button is_centered"
              color="navy"
              linkProps={{ to: "/" }}
            >
              Take Me Home
            </Button>
          </div>
        </div>
      </ImgixBackgroundImage>
    </main>
  );
};

export default PageNotFound;
